import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function FileCabinet(props) {
  const orange = getColorValue('illustrationOrange');
  const purple = getColorValue('illustrationPurple');
  const blue = getColorValue('illustrationAccent');
  const line = getColorValue('illustrationLine');
  const drawer = getColorValue('illustrationDrawer');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m189.59 111.22s4.25-48.82-.19-67.22h-108.9397s7.15 42.25-.39 67.22c0 0 109.8097-.39 109.5197 0z"
        fill={orange}
      />
      <path
        d="m170.941 79.1197c1.51-.1 1.52-1.22 0-1.35-2.13-.18-4.38-.29-7.26-.32-3.27.03-4.09.25-6.3.21-3.74-.03-10.06-.39-11.58-.48-.22-.01-.45-.02-.68-.01-1.61.03-8.68.14-14.77.01-4.3-.03-6.96-.05-8.35-.06-3.28-.02-5.74.08-8.15.27-1.32.11-1.33 1.08 0 1.2 2.41.23 4.86.37 8.14.4 1.28.01 3.93.3 7.68.38.61.01 1.22 0 1.83-.04 5.24-.32 12.03-.16 12.03-.16s10.14.09 14.41.12c3.22.02 4.77.03 5.72.04 2.88.02 5.13-.05 7.27-.2z"
        fill={line}
      />
      <path
        d="m170.681 60.5806c1.86-.1 1.86-1.22 0-1.35-2.63-.18-5.39-.29-8.95-.32-4.03.03-5.03.25-7.76.21-4.61-.03-12.39-.39-14.26-.48-.28 0-.55-.02-.83 0-1.99.03-10.7.14-18.19 0-5.3-.03-8.57-.05-10.29-.06-4.04-.02-7.07.08-10.03.27-1.6302.11-1.6402 1.08 0 1.2 2.96.23 5.99.37 10.03.4 1.57 0 4.84.3 9.46.38.75 0 1.51 0 2.25-.04 6.45-.32 14.81-.16 14.81-.16s12.48.09 17.75.12c3.97.02 5.88.03 7.05.04 3.55.02 6.32-.05 8.95-.2z"
        fill={line}
      />
      <path
        d="m116.06 87.9705-5.9-13.41h-46.9901v3.25h.01v94.1005h142.9901v-83.9405z"
        fill={purple}
      />
      <path
        d="m171.46 101.5v17.43c-18.4 4.44-67.22.19-67.22.19.2.15.2-8.74.15-17.62h-50.39v129.21h167.7v-129.21z"
        fill={blue}
      />
      <path
        d="m104.971 190.13v-9.86h58.2l5.81 9.86z"
        fill={illustrationColors.staticDarkBlue}
      />
      <path d="m182.921 166.471-4.88-22.33-84.5703 2.47v19.86z" fill={drawer} />
    </svg>
  );
}

export default FileCabinet;
